import {isSystemChangeRequestDto} from '@domain/shifthandover'
import {
  ChangeFunction,
  EventStatus,
  ShiftEventDto,
  StatusListWithApproverStates
} from '@hconnect/common/types'

import {SystemChangeRequestTableItem} from '../types'

const EXECUTED_CHANGE_REQUEST_STATUSES: EventStatus<StatusListWithApproverStates>[] = [
  'implemented',
  'done'
]

export const mapToSystemChangeRequestTableItem = (
  item: ShiftEventDto,
  changeFunctions: ChangeFunction[] | undefined
): SystemChangeRequestTableItem => {
  if (!isSystemChangeRequestDto(item)) {
    return {
      id: item.id,
      title: item.title,
      functionId: undefined,
      functionName: undefined,
      validFrom: undefined,
      validTo: undefined
    }
  }

  const functionId = item.parameterChange?.functionId
  const functionName = changeFunctions?.find(
    (changeFunction) => changeFunction.id === functionId
  )?.name

  const getValidDates = () => {
    if (item.schedule) {
      return {
        validFrom: item.schedule.startDate,
        validTo: item.schedule.endDate
      }
    }

    if (EXECUTED_CHANGE_REQUEST_STATUSES.includes(item.status)) {
      return {
        validFrom: item.lastModifiedStatus,
        validTo: undefined
      }
    }

    return {
      validFrom: undefined,
      validTo: undefined
    }
  }

  const {validFrom, validTo} = getValidDates()

  return {
    id: item.id,
    title: item.title,
    functionId,
    functionName,
    validFrom,
    validTo
  }
}
